export interface FaqItem {
  question: string;
  answer: string;
}

export interface NavItem {
  label: string;
  path: string;
}

export const siteInfo = {
  name: "黑料每日",
  slogan: "早报与一瓜，每日精选必看合集",
  description:
    "每天固定更新早报和一瓜，精选当日娱乐行业热门话题与幕后观察，合集整理方便快速浏览，点开即可获取完整瓜单。",
  email: "hello@heiliaodaily.example.com",
  tipEmail: "tips@heiliaodaily.example.com",
  since: "2024",
  updateTime: "每日 07:30 更新早报 · 20:00 更新一瓜",
};

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "每日早报", path: "/morning" },
  { label: "每日一瓜", path: "/gossip" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const hotTags: string[] = [
  "短剧出海",
  "临阵换角",
  "综艺剪辑",
  "演唱会成本",
  "会员涨价",
  "分账模式",
  "影视基地排期",
  "音乐节退票",
  "平台留存",
  "剧组后勤",
];

export const faqs: FaqItem[] = [
  {
    question: "黑料每日多久更新一次？",
    answer:
      "我们每个自然日固定更新两档内容：早报在早上 7:30 前后发布，汇总当日值得关注的行业动态；一瓜在晚上 20:00 前后发布，侧重单个话题的深度梳理。节假日不休更。",
  },
  {
    question: "站内内容是怎么筛选出来的？",
    answer:
      "编辑组会先收集公开的行业信息与读者投稿，再按「信息完整度、是否有可核查的公开来源、是否具备讨论价值」三条标准做筛选。无法确认来源的内容不会进入正式栏目。",
  },
  {
    question: "可以投稿或者报料吗？",
    answer:
      "可以。你可以通过「联系我们」页面的表单提交线索，或发送邮件到我们的报料邮箱。提交时请尽量附上公开来源链接或时间线，方便编辑组快速判断与跟进。",
  },
  {
    question: "为什么有些话题没有继续跟进？",
    answer:
      "当一则话题缺少新的公开信息，或者涉及无法核实的具体指向时，我们会选择暂停跟进而不是反复复述。这样做的目的是保持内容的信息增量，避免无意义的重复。",
  },
  {
    question: "网站内容可以转载吗？",
    answer:
      "站内原创内容欢迎在注明来源与原文链接的前提下转载。涉及图片素材的部分，请以素材原始授权为准，我们不代为授权第三方图片。",
  },
  {
    question: "有广告合作或内容合作方式吗？",
    answer:
      "有。品牌与内容合作请通过「联系我们」页面的表单说明合作类型与预期形式，我们会在三个工作日内回复，并同步告知可用的展示位置与排期。",
  },
];

export const testimonials: { name: string; role: string; quote: string }[] = [
  {
    name: "林澈",
    role: "通勤党 · 早报读者",
    quote:
      "早上地铁上两分钟看完早报，基本就知道昨天行业里发生了什么，比到处翻热搜省事多了。",
  },
  {
    name: "苏漫",
    role: "影视从业者",
    quote:
      "一瓜那部分写得比很多快讯认真，会讲清楚背后的机制，不只是把结论抛给你。",
  },
  {
    name: "陈默",
    role: "内容运营",
    quote:
      "分类整理得很清楚，找选题的时候直接按栏目翻，效率比搜索高。",
  },
];

export const stats: { value: string; label: string }[] = [
  { value: "700+", label: "已更新期数" },
  { value: "12 万", label: "订阅读者" },
  { value: "2 档", label: "固定日更栏目" },
  { value: "5 类", label: "内容分类" },
];